import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'
// 登录登出/获取用户信息/公司接口

// 登录接口
export const login = params => {
    return post("/admin/login", params);
};
// 刷新token
export const reqToken = params => {
    return post("/admin/refresh_token");
};
// export const login = params => {
//     return loginreq("post", "/admin/login", params);
// };
// 获取用户信息
export const getUserInfo = params => {
    return get("/admin/getUserInfo", params);
};
// 获取公司
export const getCompanysList = params => {
    return get("/admin/companys", params);
};
// 新增公司
export const addCompanyData = params => {
    return post("/admin/companys", params);
};
// 删除公司
export const deleteCompany = params => {
    return del(`/admin/companys/${params}`);
};
// 修改公司信息
export const editCompany = params => {
    const id = params.id
    delete params.id
    return put(`/admin/companys/${id}`, params);
};
// 公司回收站
export const getDeleteList = params => {
    return get("/admin/companys/getCompanyDeleteList", params);
};
// 回收站彻底删除
export const alldeleteCompany = params => {
    return del(`/admin/companys/companyForceDelete/${params}`);
};
// 恢复
export const findeditCompany = params => {
    return put(`/admin/companys/restoreCompany/${params.id}`);
};
// 上传图片
export const pushImg = params => {
    return post("/admin/uploadFile", params);
};
// 退出
export const loginOut = params => {
    return post("/admin/loginout", params);
};
// 获取用户菜单
// export const menu = params => {
//     return axios
//         .get("/api/menu?&token=" + localStorage.getItem("logintoken"))
//         .then(res => res.data);
// };
// 退出接口
// export const loginout = () => {
//     return axios
//         .delete("/api/login?&token=" + localStorage.getItem("logintoken"))
//         .then(res => res.data);
// };
// 获取公司管理列表数据



// WEBPACK FOOTER //
// ./src/api/userMG.js